function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { useState } from 'react';
import { parseAsBool } from '@guryou/utils';
import { Checkbox as MuiCheckBox, FormControlLabel } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import { Block } from '../content';
const CheckBox = props => {
  const {
    value: initialVal,
    color,
    label,
    margin,
    onChange,
    inputRef,
    number,
    fullWidth,
    xs,
    md,
    checked = null,
    customMargin,
    ...rest
  } = props;
  const [localChecked, setLocalChecked] = useState(checked !== null ? checked : parseAsBool(initialVal));
  const onChangeHandler = event => {
    if (onChange) {
      onChange(event.target.checked);
    }
    setLocalChecked(event.target.checked);
  };
  const inputProps = {
    number
  };
  const checkBox = /*#__PURE__*/React.createElement(MuiCheckBox, _extends({
    color: color || 'primary',
    inputProps: inputProps,
    checked: localChecked,
    value: initialVal,
    onChange: event => onChangeHandler(event)
  }, rest));
  const content = /*#__PURE__*/React.createElement(FormControl, {
    margin: margin || 'normal',
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    inputRef: inputRef,
    label: label,
    control: checkBox,
    margin: "normal",
    className: "checkbox ".concat(rest.className),
    style: {
      margin: customMargin ? customMargin : 'normal'
    }
  }));
  if (xs || md) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md
    }, marginProps), content);
  }
  return content;
};
CheckBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  color: PropTypes.string,
  onClick: PropTypes.func
};
export default CheckBox;